{
  "$schema": "./schema.json",
  "bankID": {
    "common": {
      "startBankId": "Identifiera dig",
      "pleaseWait": "Vänligen vänta...",
      "canceledTitle": "Avbruten",
      "loginCancelled": "Autentiseringen avbröts",
      "authenticationError": "Autentisering misslyckades. Försök igen.",
      "back": "Tillbaka",
      "continue": "Fortsätt",
      "cancel": "Avbryt"
    },
    "SE": {
      "startBankId": "Identifiera dig",
      "writeSecurityCode": "Skanna QR-kod eller ange säkerhetskod",
      "autostartTitle": "Öppnar BankID...",
      "autostartDescription": "BankID-appen öppnas automatiskt. Följ instruktionerna i appen.",
      "bankIdOnThisDevice": "Använd BankID på den här enheten",
      "bankIdOnAnotherDevice": "Använd BankID på en annan enhet",
      "bankIdTestFlow": "Testflöde (med personnummer)",
      "qrCodeInstructions": "Så här använder du",
      "qrCodeStep1": "Öppna BankID-appen på din mobila enhet",
      "qrCodeStep2": "Tryck på 'Skanna QR-kod'",
      "qrCodeStep3": "Rikta kameran mot QR-koden ovan",
      "qrCodeStep4": "Följ instruktionerna i BankID-appen",
      "abortLogin": "Avbryt autentisering",
      "ssn": "Personnummer",
      "ssnHelper": "Ange ditt svenska personnummer",
      "ssnPlaceholder": "ÅÅÅÅMMDD-XXXX",
      "giveValidSSN": "Ange ett giltigt personnummer"
    },
    "FI": {
      "selectBank": "Välj din bank",
      "authInProgress": "Autentisering pågår",
      "authInProgressDescription": "Slutför autentiseringen i popup-fönstret eller den nya fliken. Stäng inte detta fönster.",
      "noBankIdInfo": "Har du inte BankID?",
      "getBankIdLink": "Skaffa BankID här"
    },

    "errors": {
      "genericError": "Autentisering misslyckades. Försök igen.",
      "userCancelled": "Du avbröt autentiseringen.",
      "unauthorized": "Du har inte tillgång till den här tjänsten",
      "timeout": "Autentiseringen gick ut. Försök igen.",
      "startFailed": "Misslyckades att starta autentisering. Försök igen.",
      "popupBlocked": "Popup blockerades av webbläsaren. Tillåt popups och försök igen.",
      "networkError": "Nätverksfel. Kontrollera din anslutning och försök igen."
    }
  }
}
